import { render, staticRenderFns } from "./passengerInfo.vue?vue&type=template&id=495df5a4&scoped=true&"
import script from "./passengerInfo.vue?vue&type=script&lang=js&"
export * from "./passengerInfo.vue?vue&type=script&lang=js&"
import style0 from "./passengerInfo.vue?vue&type=style&index=0&id=495df5a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495df5a4",
  null
  
)

export default component.exports